<template>
  <div>
    <div class="flex-none mx-0 md:mx-64 flex justify-center template-add-type-buttons">


      <pbc-toggle-button v-model='isImage' class="template-add-type-icon" mode='outline'>
        <image-icon :size='32'/>
        <span class="type-label">Images</span>
      </pbc-toggle-button>
      <pbc-toggle-button v-model='isSticker' class="template-add-type-icon" mode='outline'>
        <sticker-emoji :size='32'/>
        <span class="type-label">Stickers</span>
      </pbc-toggle-button>
      <pbc-toggle-button v-model='isVideo' class="template-add-type-icon" mode='outline'>
        <movie :size='32'/>
        <span class="type-label">Videos</span>
      </pbc-toggle-button>
      <pbc-toggle-button v-model='isUpload' class="template-add-type-icon" mode='outline'>
        <upload :size='32'/>
        <span class="type-label">Upload</span>
      </pbc-toggle-button>
    </div>

    <recently-used-assets @select-image='onSelectUploadedImage($event, false)' 
                          @select-pack='onSelectPack($event, false)'
                          @select-animation='onSelectAnimation($event, false)'
      />

    <view-tenor-videos v-if='isVideo' :partutil='partutil'
                        @select-animation='onSelectAnimation' 
                        />

    <view-gfycat-stickers v-if='isSticker' 
                          @select='onSelectSticker' 
                          :partutil='partutil'  />


    <instant-select-pack v-if='isImage'
                      :partutil='partutil'
                      :render-tools='renderTools'
                      :grid='true'
                      :selected-layers='selectedLayers'
                      :layers='layers'
                      :holder-data='holderData'
                      @select-uploaded-image='onSelectUploadedImage'
                      @select-image='onSelectPack'
                      @select-toy='onSelectToy'

                      />

    <image-uploader v-if='isUpload'
                    game-id='gameId'
                    class="w-full mt-4 px-4" 
                    @uploaded='onUpload'
                    :is-short-mode='true'
                    :already-uploaded='uploadedImages'
                    @select='onSelectUploadedImage'
                    />
  </div> 
</template>
<script>

import Upload from '@icons/Upload.vue';
import Movie from '@icons/Movie.vue';
import StickerEmoji from '@icons/StickerEmoji.vue';
import Image from '@icons/Image.vue';
import ViewTenorVideos from '@ui/molecules/ViewTenorVideos.vue';
import ViewGfycatStickers from '@ui/molecules/ViewGfycatStickers.vue';
import AddStickers from '@ui/organisms/AddStickers.vue';
import InstantSelectPack from '@ui/molecules/InstantSelectPack.vue';
import ImageUploader from '@ui/molecules/ImageUploader.vue';
import RecentlyUsedAssets from '@ui/molecules/RecentlyUsedAssets.vue';

export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    selectedLayers: {
      type: Object,
      required: true
    },
    layers: {
      type: Object,
      required: true
    },
  },
  data() {
    const gamedata = this.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedImages) === 'undefined') {
      this.$set(gamedata, 'uploadedImages', []);
    }
    const uploadedImages = gamedata.uploadedImages;

    return {
      uploadedImages
    }
  },
  components: {
    ViewTenorVideos,
    ViewGfycatStickers,
    InstantSelectPack,
    ImageUploader,
    RecentlyUsedAssets,
    Movie,
    StickerEmoji,
    Upload,
    ImageIcon: Image

  },
  methods:{
    onSelectSticker(animation) {
      this.$emit('select-sticker', animation);
      this.$store.commit('addRecentlyUsedAsset', {
        type:'animation',
        data:animation
      });
    },
    onSelectAnimation(animation, addToRecent=true) {
      this.$emit('select-video', animation);
      if (addToRecent) {
        this.$store.commit('addRecentlyUsedAsset', {
          type:'animation',
          data:animation
        });
      }
    },
    onUpload(data) {
      this.uploadedImages.push(data);
    },
    onSelectUploadedImage(data, addToRecent=true) {
      console.log('select', data);
      if (data.__type === 'image') {
        console.log('on select uploaded image', data);
        this.$emit('select-uploaded-image', data);
      } else if (data.__type === 'animation') {
        this.onSelectAnimation(data);
      }
      if (addToRecent) {
        this.$store.commit('addRecentlyUsedAsset', {
          type:'image',
          data:data
        });
      }
    },
    onSelectPack(data, addToRecent=true) {
      console.log('select image', data);
      this.$emit('select-pack', data);
      if (addToRecent) {
        this.$store.commit('addRecentlyUsedAsset', {
          type:'pack',
          data:data
        });
      }
    },
    onSelectToy({layer,toysheet,toy,position}) {
      console.log('select toy', layer, toysheet, toy, position);
      this.$emit('select-toy', {
        layer,
        toysheet,
        toy,
        position
      });
    },

  },
  watch:{
    mode(nv) {
      this.$ana.track({
        eventCategory:'add',
        eventAction:nv
      });
    }
  },
  computed: {
    mode: {
      get() {
        return this.$store.state.selectedAddMode;
      },
      set(nv) {
        this.$store.commit('setSelectedAddMode', nv);
      }
    },
    isSticker: {
      set(nv) {
        this.mode = "sticker"
      },
      get() {
        return this.mode === 'sticker';
      }
    },
    isVideo: {
      set(nv) {
        this.mode = "video"
      },
      get() {
        return this.mode === 'video';
      }
    },
    isImage: {
      set(nv) {
        this.mode = "image"
      },
      get() {
        return this.mode === 'image';
      }
    },
    isUpload: {
      set(nv) {
        this.mode = "upload"
      },
      get() {
        return this.mode === 'upload';
      }
    },

  }
  
}
</script>
<style>
.add-type-icon {
  @apply px-1 py-1 flex flex-row;
}
@media (min-width:360px) {
  .add-type-icon {
    @apply p-2;
  }
}
.add-type-icon .type-label {
  @apply text-xs font-thin;
}
.add-type-buttons > .pbc-toggle-button-outlined-on {
  @apply bg-blue-700 text-white;
}
</style>
